module.exports = __webpack_public_path__ + "static/media/FENGYUN 2E.d11adaaf.czml";